import { render, staticRenderFns } from "./ClienteleServicesDialog.vue?vue&type=template&id=4e55d5c2"
import script from "./ClienteleServicesDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClienteleServicesDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ClienteleServicesDialog.vue?vue&type=style&index=0&id=4e55d5c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports